import React from 'react';
import './CompanyPage.css';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';

const HISTORY = [
  { date: '2019年3月', text: 'PortRay株式会社 設立' },
  { date: '2019年', text: '有料職業紹介事業許可取得（13-ユ-314535）' },
  { date: '2022年11月', text: 'きらぼし銀行アクセラレーターに採択' },
  { date: '2024年5月', text: 'B Dash Camp 2024 Sapporo ファイナリスト選出' },
  { date: '2025年9月', text: 'OSUMITSUKI「スキルの通知表 / スキルの拡張パック」リリース' },
];

const PROFILE = [
  { label: '社名', value: 'PortRay株式会社' },
  { label: '設立', value: '2019年3月', num: true },
  { label: '代表者', value: '代表取締役　鹿野翔太' },
  { label: '資本金', value: '5,853万円', num: true },
  { label: '所在地', value: '〒107-0061　東京都港区北青山２丁目１２番８号　BIZSMART' },
  { label: '事業許可番号', value: '有料職業紹介事業許可番号　13-ユ-314535' },
];

const BUSINESS = [
  { title: '転職のセンター試験', text: '共通の評価基準による転職支援サービス' },
  { title: 'スキル評価プラットフォーム', text: '人材の実力を可視化する評価システム' },
  { title: '人材育成支援', text: '1on1育成プログラムによる人材開発' },
];

function CompanyPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: '会社案内', path: '/company' }
  ];

  return (
    <div className="company-page">
      <SEO page="company" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">COMPANY</p>
          <h1 className="ds-h1">会社案内</h1>
          <p className="ds-lead">
            当社は、組織・人材マネジメントとキャリア形成支援を行うために<br />
            膨大な「人材評価データ」を集積・活用する総合型人材ソリューション企業です。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="company-mvv">
            <div className="company-mvv-row">
              <p className="ds-eyebrow">MISSION</p>
              <p className="ds-h2 company-mvv-text">
                就職活動を<em>なくす</em>
              </p>
            </div>
            <div className="company-mvv-row">
              <p className="ds-eyebrow">VISION</p>
              <p className="ds-h2 company-mvv-text">
                キャリアに<em>無限の可能性</em>を作る
              </p>
            </div>
            <div className="company-mvv-row">
              <p className="ds-eyebrow">VALUE</p>
              <p className="ds-h2 company-mvv-text">
                <em>"すべて"</em>は一人の未来のために
                <br />
                <em>"おもい"</em>は行動で示す
                <br />
                <em>"できない"</em>は楽しい
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">MESSAGE</p>
            <h2 className="ds-h2">代表メッセージ</h2>
          </div>
          <div className="company-message">
            <div className="company-message-photo">
              <img src="/images/Profile.jpg" alt="代表取締役 鹿野翔太" />
            </div>
            <div className="company-message-text">
              <p>
                「就職活動をなくす」——これは私たちPortRayが掲げるミッションです。
              </p>
              <p>
                現在の採用市場では、企業ごとに異なる評価基準で選考が行われ、
                求職者は何度も同じような面接を繰り返しています。
                この非効率は、企業にとっても求職者にとっても大きな損失です。
              </p>
              <p>
                私たちは「共通の評価データ」という新しい仕組みで、
                採用のミスマッチをなくし、すべての人が自分の力を正しく評価される社会を目指しています。
                一人ひとりのキャリアに無限の可能性を作るために、これからも挑戦を続けてまいります。
              </p>
              <p className="company-message-name">代表取締役　鹿野翔太</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">HISTORY</p>
            <h2 className="ds-h2">沿革</h2>
          </div>
          <dl className="company-table">
            {HISTORY.map((item) => (
              <div className="company-table-row" key={item.date + item.text}>
                <dt className="ds-num">{item.date}</dt>
                <dd>{item.text}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">PROFILE</p>
            <h2 className="ds-h2">企業情報</h2>
          </div>
          <dl className="company-table">
            {PROFILE.map((item) => (
              <div className="company-table-row" key={item.label}>
                <dt>{item.label}</dt>
                <dd className={item.num ? 'ds-num' : undefined}>{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">BUSINESS</p>
            <h2 className="ds-h2">事業内容</h2>
          </div>
          <div className="company-business">
            {BUSINESS.map((item) => (
              <div className="ds-card company-business-card" key={item.title}>
                <h3 className="ds-h3">{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default CompanyPage;
